import React, {  useState } from "react";
import icons from "../../../../../Data/icons";
import { useQuery } from "react-query";
import { getSalary } from "../../../../../MyApi/hr/salary";
import LoadingSpinner from "../../../../UI/spinner";
const SalaryComponentStore = ({
  row,
  setSalaryComponentObject,
  handleAddRow,
  classes,
  setRows,
  rows,
  salaryComponentObject,
  handleRemoveRow
}) => {
  const [amount , setAmounts]= useState("")
  const [salaryId , setSalaryId]=useState("")
  const Add = icons.add;
  const Trash=icons.trash




let prevItem = salaryComponentObject[row.id] ||{
  amount :0 ,id :""
}

  const { data, isLoading } = useQuery("getSalary", getSalary);
  const salaries = data?.data || [];



  const handleAmountChange =(e)=>{
  setAmounts(e.target.value)
  const value=  +e.target.value
  setSalaryComponentObject(

    {
      ...salaryComponentObject,
      [row.id] :{...prevItem ,amount :value}
    }
  )
  

  }
  const  handleSalayIdChange =(e)=>{ 
    const IdSalary= +e.target.options[e.target.selectedIndex].id
   
 setSalaryComponentObject({
  ...salaryComponentObject,
   [row.id]:{...prevItem , id:IdSalary}})
  }

  if(isLoading){
    return <LoadingSpinner/>
  }
  return (


<div className={classes.salaryRow} >
      <input
        type="number"
        name="amounts[]"
        value={amount}
        onChange={handleAmountChange}
        placeholder="ادخل   الكمية"
        className={classes.inputCustom}
      />
      {!data ? (
        <div>no data avalible</div>
      ) : (
        <select id="salaries" name="hr_salary_component_ids[]"  className={classes.inputCustom} onChange={handleSalayIdChange}> 
          <option value="">اختار الراتب</option>
          {salaries.map((salary) => (
            <option key={salary.id} id={salary.id} selected={salary.id ===salaryId}>
              {salary.name}
            </option>
          ))}
        </select>
      )}

      <button onClick={()=>handleAddRow(row.id)} className={classes.addBtn}>
  
        <Add />
      </button>  
          <button onClick={()=>handleRemoveRow(row.id)} className={classes.removeBtn} >  <Trash/></button>
    </div>
 


  );
};

export default SalaryComponentStore;
